import { OvertimeWorkedAndScheduledPerPeriodModel, PeriodModel } from '../../models/OvertimeSchedule';
import {
  getTotalDifferenceForWeek,
  getTotalOverlapWorkedScheduledForWeek,
  getTotalScheduledOvertimeForWeek,
  getTotalWorkedOvertimeForWeek,
} from '../../utils/overtimeTotals.utils';
import { ResumenMetricValidation } from './cells/ResumenMetricCell';

export interface ResumenColumnConfig {
  key: string;
  label: string;
  title: string;
  icon?: string;
  iconClassName?: string;
  getValue: (period: PeriodModel) => number;
  getTotal: (data: OvertimeWorkedAndScheduledPerPeriodModel[], selectedPeriodIndex: number) => number;
  getValidation: (period: PeriodModel) => ResumenMetricValidation;
}

export const RESUMEN_COLUMNS: ResumenColumnConfig[] = [
  {
    key: 'proy',
    label: 'Proy',
    title: 'Horas proyectadas',
    icon: 'mdi mdi-calendar-clock-outline',
    iconClassName: 'text-primary2',
    getValue: (period) => period.totalScheduledOvertime,
    getTotal: getTotalScheduledOvertimeForWeek,
    getValidation: () => 'default',
  },
  {
    key: 'ejec',
    label: 'Ejec',
    title: 'Horas ejecutadas',
    icon: 'mdi mdi-clock-outline',
    iconClassName: 'text-info',
    getValue: (period) => period.totalWorkedOvertime,
    getTotal: getTotalWorkedOvertimeForWeek,
    getValidation: (period) => {
      if (period.periodAllowedOvertimeExceeded) return 'danger';
      if (period.totalWorkedOvertime > period.totalScheduledOvertime) return 'warning';
      return 'default';
    },
  },
  {
    key: 'dif-pe',
    label: 'Dif. P-E',
    title: 'Diferencia proyectadas menos ejecutadas',
    getValue: (period) => period.totalScheduledOvertime - period.totalWorkedOvertime,
    getTotal: getTotalDifferenceForWeek,
    getValidation: () => 'default',
  },
  {
    key: 'dif-pb',
    label: 'Dif. P-B',
    title: 'Diferencia proyectadas menos base',
    getValue: (period) =>
      period.totalScheduledOvertime || period.totalWorkedOvertime ? period.totalOverlapWorkedScheduled : 0,
    getTotal: getTotalOverlapWorkedScheduledForWeek,
    getValidation: () => 'default',
  },
];
